import Typography from "aldoo-ra/Typography"
import { usePageContext } from "vike-react/usePageContext"

function Footer() {
  const pageContext = usePageContext()
  const currentPath = pageContext?.currentPath || pageContext?.urlPathname || (typeof window !== 'undefined' ? window.location.pathname : '/')

  const shouldHide = currentPath?.startsWith('/admin') ||
                    (typeof window !== 'undefined' && window.location.pathname.startsWith('/admin'))

  if (shouldHide) return null

  // Local footer data
  const socialLinks = [
    { label: "Twitter", href: "https://twitter.com", icon: "🐦" },
    { label: "Facebook", href: "https://facebook.com", icon: "📘" },
    { label: "LinkedIn", href: "https://linkedin.com", icon: "💼" }
  ]

  const footerLinks = [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" }
  ]

  return (
    <footer className="w-full bg-paper border-t border-border mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
          {/* Left side */}
          <div className="flex flex-col gap-6">
            {/* Logo */}
            <div className="flex flex-row items-center gap-2">
              <div className="text-text font-bold text-xl">Your Logo</div>
            </div>

            {/* Follow Us Links */}
            <div className="flex items-center gap-4">
              <Typography
                variant="body_16"
                className="text-text my-0"
              >
                Follow us
              </Typography>

              <div className="flex items-center gap-3">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-text hover:text-primary transition-colors text-xl"
                    title={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right side */}
          <div className="flex flex-col items-center md:items-end gap-6">
            {/* Terms and Privacy */}
            <div className="flex flex-col md:flex-row items-center gap-4">
              {footerLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="text-text hover:text-primary transition-colors font-medium"
                >
                  {link.label}
                </a>
              ))}
            </div>

            <Typography
              variant="body_12"
              className="text-center md:text-right text-text_secondary my-0"
            >
              © 2025 Your Company. All Rights Reserved.
            </Typography>
          </div>
        </div>
      </div>
    </footer>
  )
}

// AldooComponent definition for auto-discovery
export const AldooComponent = {
  id: "Footer",
  component: Footer,
  description: "Footer with logo, social links, and legal links. Auto-hides on admin routes.",
  input: {},
}

export default Footer
